import React from "react";

function SearchIcon({ viewBox = "0 0 18 18", className = "" }) {
  return (
    <svg data-testid="search-icon" xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" viewBox={viewBox} className={className}>
      <g>
        <g stroke="currentColor" strokeLinecap="round" strokeLinejoin="round">
          <path d="M7.875 11.625a3.75 3.75 0 100-7.5 3.75 3.75 0 000 7.5z"></path>
          <path d="M13.875 13.875l-3.349-3.349"></path>
        </g>
      </g>
    </svg>
  );
}

export default SearchIcon;
